import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import AuthPanel from "@/components/auth-panel";

/**
 * Wraps the sign-in / sign-up panel in a modal so it can open directly on the
 * landing page instead of navigating to a separate route.
 */
export default function AuthDialog({
  open,
  onOpenChange,
  mode,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  mode: "signin" | "signup";
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md p-6 bg-white text-slate-900">
        <DialogTitle className="sr-only">{mode === "signup" ? "Sign up" : "Sign in"}</DialogTitle>
        {/* Remount on mode change so the panel opens to the right tab */}
        <AuthPanel key={mode} initialMode={mode} />
      </DialogContent>
    </Dialog>
  );
}
